import React from 'react'
import { useCurrentTypeHook } from './helperHooks/useCurrentTypeHook'

export default function CurrencyIconsView(props) {
  const { className } = props
  const CurrentType = useCurrentTypeHook()

  return (
    <>
      {CurrentType?.code && <>
        <span className={`${className}`}>
          {CurrentType?.code === "USD" ? '$' : `${CurrentType?.symbol}`}
        </span>
      </>}
    </>
  )
}
